import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PagedList, pagedListUtilities, GenericError } from '../../../common';
import PermissionEdit from '../../permission-edit';
import './program-list.scss';

export class ProgramList extends Component {

  componentDidMount() {
    const {  siteId, formId, initProgramData, fetchProgramList } = this.props;
    initProgramData(siteId, formId);
    fetchProgramList(siteId, formId);

  }

  componentWillUpdate(nextProps, nextState) {
    const {  siteId, formId, fetchProgramList } = this.props;
    fetchProgramList(siteId, formId);
  }

  handleViewChange(value, program) {
    const { siteId, formId, permissionProps } = this.props;
    const { updateProgramTouchpointPermissions } = permissionProps || {};
    updateProgramTouchpointPermissions(siteId, formId, program.id, 'view', value);
    if(value === false)
      updateProgramTouchpointPermissions(siteId, formId, program.id, 'edit', value);
  }

  renderProgram(program) {
    const { siteId, formId, permissionProps, isUnsupported } = this.props;
    const { permissions, submission, responses, updateProgramTouchpointPermissions } = permissionProps || {};
    const { permissions : programPermissions } = permissions || {};
    const { isSubmitting } = submission || {};
    const permission = programPermissions.find(permission =>
      permission.siteId === siteId &&
      permission.touchpointId === formId &&
      permission.programId === program.id);
    const { addPerm, viewPerm, editPerm } = permission || {};
    const view = responses && responses.getIn([formId, program.id, 'view']);
    const add = responses && responses.getIn([formId, program.id, 'add']);
    const edit = responses && responses.getIn([formId, program.id, 'edit']);

    const viewValue = view === undefined ? viewPerm === undefined ? false : viewPerm : view;
    const addValue = add === undefined ? addPerm === undefined ? false : addPerm : add;
    const editValue = edit === undefined ? editPerm === undefined ? false : editPerm : edit;

    return (
      <tr key={program.id}>
        <td>{program.name}</td>
        <td className="view-permission">
          <PermissionEdit
            id='viewPermission'
            ariaLabel='view'
            response={view}
            defaultValue={viewPerm}
            disabled={isSubmitting || (isUnsupported && !viewValue)}
            onChange={value => this.handleViewChange(value, program)}/>
        </td>
        <td className="add-permission">
          <PermissionEdit
            id='addPermission'
            ariaLabel='add'
            response={add}
            defaultValue={addPerm}
            disabled={isSubmitting || (isUnsupported && !addValue)}
            onChange={value => updateProgramTouchpointPermissions(siteId, formId, program.id, 'add', value)}/>
        </td>
        <td className="edit-permission">
          <PermissionEdit
            id='editPermission'
            ariaLabel='edit'
            response={edit}
            defaultValue={editPerm || (isUnsupported && !editValue)}
            disabled={isSubmitting || !viewValue}
            onChange={value => updateProgramTouchpointPermissions(siteId, formId, program.id, 'edit', value)}/>
        </td>
      </tr>);
  }

  render() {
    const { siteId, formId, programs, sortBy, sortAsc, resultsPerPage, changeSort, changePageNumber, isFetching, err, loadingMessage } = this.props;

    var programList = [];
    var currentPage = 1;
    var totalItemsCount = 0;
    if(programs) {
      programList = programs.results;
      currentPage = programs.currentPage;
      totalItemsCount = programs.totalResults;
    }

    if (err) {
      return <GenericError err={err} />
    }

    const headerNames = new Map([
      ['name', {
        displayName: 'PROGRAM',
        dataType: 'alpha',
        sortName: "name" }]]);

  const sortText =  pagedListUtilities.getSortText(headerNames, sortBy, sortAsc);
  const sortMessage = " Programs sorted by " + sortText;
  const contentLoadedMessage = "Content Loaded. " + sortMessage;

  const headerColumns = pagedListUtilities.buildSortHeader(headerNames, sortBy, sortAsc, page => changeSort(siteId, formId, page));

    const headers = (
      <tr>
        {headerColumns}
        <th className="view-permission">VIEW</th>
        <th className="add-permission">ADD</th>
        <th className="edit-permission">EDIT</th>
      </tr>
    );
    return (
      <div id='program-list'>
        <PagedList
          header={headers}
          items={programList}
          emptyMessage={<p>No Programs Found</p>}
          mapItem={site => this.renderProgram(site)}
          currentPage={currentPage}
          resultsPerPage={resultsPerPage || 1}
          totalItemsCount={totalItemsCount}
          changePageNumber={page => changePageNumber(siteId, formId, page)}
          isLoading={isFetching}
          loadingMessage={loadingMessage}
          contentLoadedMessage={contentLoadedMessage} />
      </div>
    );
  }
}

ProgramList.propTypes = {
  isUnsupported: PropTypes.bool,
  siteId: PropTypes.string,
  formId: PropTypes.string,
  programs: PropTypes.object,
  sortBy: PropTypes.string,
  sortAsc: PropTypes.bool,
  resultsPerPage: PropTypes.number,
  changeSort: PropTypes.func,
  changePageNumber: PropTypes.func,
  permissionProps: PropTypes.shape({
    permissions: PropTypes.object,
    submission: PropTypes.object,
    responses: PropTypes.object
  }),
  err: PropTypes.object,
  loadingMessage: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
};

export default ProgramList;
